import BaseService from '@/service/modules/BaseService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import FreightPriceInfo from '@/model/modules/FreightPriceInfo'

export default class UserGroupService extends BaseService {
  protected static baseUrl: string = '/freight-price'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<FreightPriceInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<FreightPriceInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<FreightPriceInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }
}
